import { Reviews } from 'components/table-reviews';

import { ICasino } from 'constants/types';

import styles from './styles.module.css';

export const ReviewsTables = ({
  casino,
  noLimit,
}: {
  noLimit?: boolean;
  casino: ICasino | undefined;
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.column}>
          <Reviews casino={casino} noLimit={noLimit} isProviderVisible />
          <div className={styles.secondReviews}></div>
        </div>
      </div>
    </div>
  );
};
